import { NgModule } from '@angular/core';
import { ProductStoreModule } from './store/search-store.module';

@NgModule({
  imports: [ProductStoreModule],
})
export class SearchDataAccessModule {}
